import script from "./Carousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./Carousel.vue?vue&type=script&lang=ts&setup=true"

import "./Carousel.vue?vue&type=style&index=0&id=3792131d&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3792131d"]])

export default __exports__